<app-navbar></app-navbar>
<div
  class="card"
  style="
    padding: 20px; //background-image: url('assets/img/school/bg.png');
    background-color: #005a63;
    background-size: 100px;
    background-attachment: fixed;
  "
>
  <h2 style="color: white; text-align: center; margin-bottom: 10px">ID Section</h2>
  <div>
    <img
      class="img-fluid"
      style="height: 500px; width: 100%; object-fit: fit; border-radius: 10px"
      src="assets/img/school/is.jpg"
    />
  </div>
  <br />
  <br />
  <div class="container" style="text-align: justify !important">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body text-justify">
            <p>
              Intellectual disability (ID) as neurodevelopmental disorders that
              begin in childhood and are characterized by intellectual
              difficulties as well as difficulties in Conceptual, social and
              practical areas of living. The age of onset for ID is 0-18 years.
              Common Characteristics of ID- such as- <br />
              <br />
              Learning and developing more slowly than other Children of the
              same age group. Rolling over, sitting up, crawling or walking much
              later, than developmentally appropriate. Difficulties in
              communicating or socializing with others. Lower than average
              scores on IQ tests (below 70) <br />
              <br />
              Based on the levels of Intelligence Quotient (IQ), the four levels
              of Intellectual disabilities 1ane+ Mild, Moderate, Severe and
              profound. And in terms of development Work is done to improve
              intellectual development by providing teaching and necessary
              therapy (OT, PT, SLT, Psychology) services through task Analysis
              [Shaping, chaining, prompting, Modeling, Reinforcement of these
              backward children. <br />
              <br />
              ID class works with Language and Communication skill,
              Socialization, ADL and behavior modification. Also, emphasis in
              given to include children in the mainstream of society based on
              their ability through Co-Curriculum activities such as singing,
              Dancing, swimming, Drawing, sports, computer training and
              pre-vocational work.
              <br />
              <br />
              Children with special needs students are involved to the NCTB
              Curriculum based on the child's ability. From this ID class, the
              children are sent to the primary, section based on their ability.
              <br />
              <br />
              At present, there are two shift (Morning & Day) and two section A&
              B. in this class. There are 30 students in two section.<br />
              <br />
              Services are provided under the supervision of two teacher and two
              Teaching assistants. As a result, the Learning process of the
              Children is easy, smooth and accelerated and the learning process
              is prolonged for child.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
